import {
  useEffect,
  useState,
  lazy,
  useLayoutEffect,
  Suspense,
  useMemo,
} from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux/rootReducers";
//import "nprogress/nprogress.css";
import "./App.scss";
import i18n from "./i18n";
import ThemeContext from "./ThemeContext";
import { lang } from "./models";
import { partnerThemeCrudOperations } from "./redux/actions/getPartnerTheme";
import useSessionExpiration from "./CustomHooks/useSessionExpire";

import { Toaster } from "./components-shadcn/ui/toaster";

import {
  handleSetLogoAndTitle,
  setBrowserTabImageAndLogo,
} from "./utils/commonFunctions";

const Accounts = lazy(() => import("./screens/AdminAccounts"));
const MainDashboard = lazy(
  () => import("./screens/adminMainDashboard/adminMainDashboard")
);
const ThreatDashBoard = lazy(() => import("./screens/AdminThreatsDashboard"));
// const UrpayTransactions = lazy(() => import("./screens/paymentGatewayScreen/UrpayTransactions"));
const SadadTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/SadadTransactions")
);
/* const MananfithTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/ManafithTransactions")
); */

//payoutSystem
const PayoutSystem = lazy(() => import("./screens/AdminPayout/PayoutSystem"));
/* const PayoutMerchants = lazy(
  () => import("./screens/AdminPayout/merchantsScreens/Merchants")
); */
//const FeeProfiles = lazy(() => import("./screens/AdminPayout/FeeProfiles"));
/* const PaymentSchedule = lazy(
  () => import("./screens/AdminPayout/PaymentSchedule")
); */
//const Transactions = lazy(() => import("./screens/AdminPayout/Transactions"));
/* const TransferCharges = lazy(
  () => import("./screens/AdminPayout/TransferCharges/TransferCharges")
); */
/* const PayoutReports = lazy(
  () => import("./screens/AdminPayout/reportsScreens/Reports")
); */
//const PayoutAuditlog = lazy(() => import("./screens/AdminPayout/AuditLogs"));
//payoutSystem

const FallBackComponent = lazy(
  () => import("./components/FallBackComponent/FallBackComponent")
);
const RouteAuth = lazy(() => import("./components/RouteAuth/RouteAuth"));
//const NotifReport = lazy(() => import("./screens/Notifications/ViewNotification"));
/* const ThreatsDashboard = lazy(
  () => import("./screens/AdminThreatsDashboard/ThreatsDashboard")
); */
const Logs = lazy(() => import("./screens/AdminLogs/Logs"));
const AdminNotification = lazy(() => import("./screens/Notifications"));
const ClickToPayTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/ClickToPay")
);
const ApplePay = lazy(() => import("./screens/paymentGatewayScreen/Applepay"));
const PartnersReports = lazy(() => import("./screens/Partners/ParnterReports"));
const AdminPaymentDashboard = lazy(
  () => import("./screens/AdminPaymentDashboard/AdminPaymentDashboard")
);
const OnlineRegisteration = lazy(
  () => import("./screens/AdminOnlineRegisteration/registerationLayout")
);
const MercahntSoftposDashboard = lazy(
  () => import("./screens/merchantSoftposDashboard/merchantSoftposDashboard")
);
const MerchantAllDashboard = lazy(
  () => import("./screens/MerchantDashboard/MerchantAllDashboard")
);
const MerchantList = lazy(() => import("./screens/AdminMerchantList"));
const PartnerList = lazy(() => import("./screens/AdminPartnerList"));
/* const SendNotification = lazy(
  () => import("./screens/Notifications/SendNotifications")
); */
const ViewNotification = lazy(
  () => import("./screens/Notifications/ViewNotification")
);
const UserManagementIndex = lazy(
  () => import("./screens/MerchantSettings/UserManagementIndex")
);
const AdminSoftposDashboard = lazy(
  () => import("./screens/AdminSoftposDashboard/AdminDashboard")
);
const TamaraTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/Tamaratransactions")
);
const TabbyTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/TabbyTransactions")
);
const CardApplepay = lazy(
  () => import("./screens/paymentGatewayScreen/CardApplepay")
);
const LoginScreen = lazy(() => import("./screens/LoginScreen"));
const AdminSettings = lazy(
  () => import("./screens/AdminUserManagement/Profile")
);
const Transaction = lazy(
  () => import("./screens/paymentGatewayScreen/Transaction")
);
/* const Layout = lazy(() => import("./screens/Layout/Layout"));
 */ const MerchantPurchase = lazy(
  () => import("./screens/CheckoutTestPages/PurchaseIniaite")
);
const PurchaseStatus = lazy(
  () => import("./screens/CheckoutTestPages/PurchaseStatus")
);
const AppMngmnet = lazy(() => import("./screens/AppMngmnt/AppMngmnet"));
const CreateInvoiceCopy = lazy(
  () => import("./screens/E-invoiceNew/CreateInvoiceScreen")
);
const InvoiceHistory = lazy(
  () => import("./screens/E-invoiceNew/InvoiceHistory")
);
const InvoiceScreen = lazy(
  () => import("./screens/EVoiceScreen/InvoiceScreen")
);
const PaymentMethodsIndex = lazy(
  () => import("./screens/AdminPaymentMethods/PaymentMethods")
);
const Reports = lazy(() => import("./screens/AdminReports/Reports"));
const ProductMng = lazy(() => import("./screens/Products/ProductMng"));
const Customers = lazy(() => import("./screens/Customers/Customers"));
const Configuration = lazy(
  () => import("./screens/AdminConfiguration/Configuration")
);
const PaymentGatewayDashboard = lazy(
  () => import("./screens/PaymentGatewayDashboard/PaymentGatewayDashboard")
);
const MerchantPayoutTransactions = lazy(
  () =>
    import("./screens/MerchantPayoutTransactions/MerchantPayoutTransactions")
);
const CommercialProposal = lazy(
  () => import("./screens/CommercialProposal/CommercialProposal")
);
const CardPaymentStatus = lazy(
  () => import("./screens/CardPaymentStatus/CardPaymentStatus")
);
const InVoicePayment = lazy(
  () => import("./screens/InvoicePayment/InvoicePayment")
);
const SDKPaymentOptions = lazy(
  () => import("./screens/SDKPaymentOptions/SDKPaymentOptions")
);
const SDKPaymentOptions2 = lazy(
  () => import("./screens/SDKPaymentOptions/SDKPaymentClicToPay")
);
const SDKPaymentOptions3 = lazy(
  () => import("./screens/SDKPaymentOptions/SDKPaymentOptions2")
);
const PaymentSettings = lazy(() => import("./screenSettings/PaymentSettings"));
const BranchesScreen = lazy(
  () => import("./screens/BranchesScreen/BranchesScreen")
);
const UsersScreen = lazy(() => import("./screens/UsersScreen/UsersScreen"));
const TerminalsScreen = lazy(
  () => import("./screens/TerminalsScreen/TerminalsScreen")
);
const TransactionsScreen = lazy(
  () => import("./screens/TransactionsScreen/TransactionsScreen")
);
const TerminalsReconcilationScreen = lazy(
  () => import("./screens/ReconcilationScreen/TerminalsReconcilationScreen")
);
const OTPScreen = lazy(() => import("./screens/OTPScreen"));
const Forgetpassword = lazy(() => import("./screens/ForgetPassword"));
const EmailReceipt = lazy(
  () => import("./components/EmailReceipt/ReceiptScreen")
);
const Merchant = lazy(() => import("./screens/Merchant"));

const RegisterPage = lazy(
  () => import("./screens/RegisterScreen/RegisterScreen")
);
const PasswordResetScreen = lazy(
  () => import("./screens/PasswordResetScreen/PasswordResetScreen")
);
const ErrorUrlScreen = lazy(() => import("./screens/ErrorUrlScreen"));
const MerchantItem = lazy(() => import("./screens/MerchantItem"));
const OutletScreen = lazy(() => import("./screens/OutletScreen"));
const TerminalScreen = lazy(() => import("./screens/TerminalScreen"));
const UserScreen = lazy(() => import("./screens/UserScreen/UserDetail"));
const Profile = lazy(() => import("./screens/Profile"));
const ReconsilationReceipt = lazy(
  () => import("./screens/ReconcilationScreen/ReceiptScreen")
);
const SettingsScreen = lazy(() => import("./screens/settings/SettingsScreen"));
const OtherSettings = lazy(() => import("./screenSettings/OtherSettings"));

// theme.js

const Roles = {
  admin: "admin",
  merchant: "merchant",
  user: "user",
  supervisor: "supervisor",
  partner: "partner",
};

const App = () => {
  const [loggedIn, setLoggedIn] = useState("");
  const dispatch = useDispatch();
  const authApi = useSelector((state: RootState) => state.authReducer);
  const divs = document.getElementsByTagName("div");
  const hostName = window.location.hostname;
  const handleSessionExpire = useSessionExpiration();
  const PartnerThemeApi: any = useSelector(
    (state: RootState) => state.partnerThemeCrudOperationsReducer
  );
  useLayoutEffect(() => {
    dispatch(partnerThemeCrudOperations(/*authApi.token,*/ "get", hostName));
  }, []);

  useEffect(() => {
    if (PartnerThemeApi?.themeData?.content) {
      const themesConfig = PartnerThemeApi?.themeData?.content[0];
      const AvailbelCountry = () => {
        const SAAvialablePhoneCountry: Country[] = [themesConfig.countryCode];
        return SAAvialablePhoneCountry;
      };
      const defaultCountry = () => {
        const SADefaultCountry: Country | any = themesConfig.countryCode;
        return SADefaultCountry;
      };
      setPartners({
        partner: {
          name: themesConfig.name,
          nameAR: themesConfig.nameAR,
          hostname: themesConfig.hostName,
          mainDarkColorhexa: themesConfig.mainSecondaryColorHexa,
          mainDarkColorRgba: themesConfig.mainSecondaryColorRgba,
          MainGreenColorHexa: themesConfig.mainPrimaryColorhexa,
          MainGreenColorRgba: themesConfig.mainPrimaryColorRgba,
          mainLightGreenColor: themesConfig.mainSecondaryColorHoverRgba,
          loginPagelogo: themesConfig.loginPagelogo,
          smallLogo: themesConfig.smallLogo,
          loginFigureImage: themesConfig.loginFigureImage,
          loaderImage: themesConfig.loaderImage,
          currencyEn1: themesConfig.currencyEn,
          currencyAr1: themesConfig.currencyAr,
          AvailbelCountry: AvailbelCountry(),
          defaultCountry: defaultCountry(),
          StartPhoneNum: themesConfig.startPhoneNum,
          partnerId: themesConfig.partnerId,
          footer: themesConfig?.footer,
          projects: {
            softPos: themesConfig.projects.softPos,
            paymentGateway: themesConfig.projects.paymentGateway,
            invoicing: themesConfig.projects.invoicing,
          },
        },
      });
    }
  }, [PartnerThemeApi]);

  type CountryCode = "SA" | "PK" | "LB" | "QA" | "TN";
  type Country = CountryCode;

  var [partners, setPartners]: any = useState({});
  const changeDirection = () => {
    for (let index = 0; index < divs.length; index++) {
      if (lang != "en") {
        divs[index].classList.add("rtl");
        document.documentElement.setAttribute("dir", "rtl");
      } else {
        divs[index].classList.add("ltr");
        document.documentElement.setAttribute("dir", "ltr");
      }
    }
  };

  useLayoutEffect(() => {
    if (PartnerThemeApi?.themeData?.content) {
      try {
        localStorage.setItem("themes", JSON.stringify(partners?.partner));
      } catch (e: any) {
        localStorage.removeItem("themes");
        window.location.reload();
      }
    }
  }, [PartnerThemeApi, partners]);

  useLayoutEffect(() => {
    if (PartnerThemeApi?.themeData?.content) {
      handleSetLogoAndTitle(PartnerThemeApi?.themeData?.content[0]?.smallLogo);
      if (lang === "ar") {
        localStorage.setItem("defaultCurr", partners.partner?.currencyAr1);
        document.title = `${partners?.partner?.nameAR} | لوحة تحكم  `;
      } else {
        localStorage.setItem("defaultCurr", partners.partner?.currencyEn1);
        document.title = `${partners?.partner?.name} | Portal  `;
      }
    }
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", navigator.language?.slice(0, 2));
    }
    i18n.changeLanguage(lang);
  }, [PartnerThemeApi, lang, partners]);

  useLayoutEffect(() => {
    changeDirection();
    if (PartnerThemeApi?.themeData?.content) {
      document.documentElement.style.setProperty(
        "--mainGreenColor",
        partners.partner?.MainGreenColorHexa
      );
      document.documentElement.style.setProperty(
        "--mainDarkcolor",
        partners.partner?.mainDarkColorhexa
      );
      document.documentElement.style.setProperty(
        "--mainlightGreenColor",
        partners.partner?.mainLightGreenColor
      );
    }
  }, [PartnerThemeApi, partners, lang]);

  useLayoutEffect(() => {
    if (authApi.exp) {
      const expTime = authApi.exp - new Date().getTime();
      const expTimeout = expTime > 0 ? expTime : 0;
      if (expTimeout <= 0) {
        dispatch({ type: "RESET_AUTH" });
      } else {
        authApi.token &&
          setTimeout(() => {
            handleSessionExpire.show(true);
          }, expTimeout);
      }
    }
  }, [authApi.exp]);

  useEffect(() => {
    if (authApi.role === "admin") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "partner") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "merchant") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "user") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "supervisor") {
      setLoggedIn(authApi.role);
    } else {
      setLoggedIn("");
    }
  }, [authApi.role]);

  const setTabNameAndImage = useMemo(() => {
    if (PartnerThemeApi?.themeData?.content) {
      setBrowserTabImageAndLogo(
        partners?.partner?.smallLogo,
        partners?.partner?.name
      );
    }
  }, [partners, PartnerThemeApi]);

  return (
    Object.keys(partners).length > 0 && (
      <div className="Edfapay" dir={lang == "ar" ? "rtl" : "ltr"}>
        <ThemeContext.Provider value={partners.partner}>
          <Suspense fallback={<FallBackComponent backColor={true} />}>
            <Routes>
              {<Route path="/" element={<LoginScreen />} />}
              <Route path="/login" element={<LoginScreen />} />
              <Route path="/forget" element={<Forgetpassword />} />
              <Route path={`/Edfapay/Reciept`} element={<EmailReceipt />} />
              <Route
                path="reconciliation/receipt/:id"
                element={<ReconsilationReceipt />}
              />
              <Route
                path={`/invoicePayment/:merchantId/:invoiceId/:password`}
                element={<InVoicePayment />}
              />
              <Route path="/Register" element={<RegisterPage />} />
              <Route
                path="/merchant/checkout/:orderId/:merchantId"
                element={<SDKPaymentOptions />}
              />
              <Route
                path="/merchant/checkout/"
                element={<SDKPaymentOptions />}
              />
              <Route
                path="/merchant/checkout2/:orderId/:merchantId"
                element={<SDKPaymentOptions2 />}
              />
              <Route
                path="/merchant/checkout3/:orderId/:merchantId"
                element={<SDKPaymentOptions3 />}
              />
              <Route
                path={`/merchant/paymentStatus`}
                element={<CardPaymentStatus />}
              />
              <Route
                path={`/CommercialProposal`}
                element={<CommercialProposal />}
              />
              <Route path={"/purchase"} element={<MerchantPurchase />} />
              <Route path={"/purchaseStatus"} element={<PurchaseStatus />} />
              <Route path="*" element={<ErrorUrlScreen />} />
              <Route
                path="/*"
                element={<RouteAuth availableRoles={[Roles.admin]} />}
              >
                <Route
                  path=":accountType/mainDashboard"
                  element={<MainDashboard />}
                />
                <Route
                  path=":accountType/merchantList"
                  element={<Merchant />}
                />
                <Route
                  path=":accountType/accountsmanagement/:acountTypeReport"
                  element={<Accounts />}
                />
                <Route
                  path=":accountType/softpos/dashboard"
                  element={<AdminSoftposDashboard />}
                />
                <Route
                  path=":accountType/payment/dashboard"
                  element={<AdminPaymentDashboard />}
                />
                <Route
                  path=":accountType/softpos/threats/:pageContent"
                  element={<ThreatDashBoard />}
                />
                <Route
                  path=":accountType/userManagement"
                  element={<AdminSettings />}
                />
                <Route
                  path=":accountType/appManagement"
                  element={<AppMngmnet />}
                />
                <Route
                  path=":accountType/:projectType/methodsConfiguration/:methodType"
                  element={<PaymentMethodsIndex />}
                />
                <Route
                  path=":accountType/PartnersReports"
                  element={<PartnersReports />}
                />
                <Route
                  path=":accountType/:projectType/allReports/:reportName"
                  element={<Reports />}
                />
                <Route
                  path=":accountType/:projectType/:confiurationType/:configurationName"
                  element={<Configuration />}
                />
                <Route path=":accountType/logs/:logsType" element={<Logs />} />
                <Route
                  path=":accountType/notifications"
                  element={<AdminNotification />}
                />
                <Route
                  path=":accountType/merchants"
                  element={<MerchantList />}
                />
                <Route path=":accountType/partners" element={<PartnerList />} />
                <Route
                  path=":accountType/onlineRegisteration"
                  element={<OnlineRegisteration />}
                />
                <Route path="profile" element={<AdminSettings />} />
                {/*payout seystem*/}
                <Route path="admin/adminPayout" element={<PayoutSystem />} />
                <Route
                  path="admin/adminPayout/merchants"
                  element={<PayoutSystem />}
                />
                <Route
                  path="admin/adminPayout/feeprofiles"
                  element={<PayoutSystem />}
                />
                <Route
                  path="admin/adminPayout/payment-schedule"
                  element={<PayoutSystem />}
                />
                <Route
                  path="admin/adminPayout/transactions"
                  element={<PayoutSystem />}
                />
                <Route
                  path="admin/adminPayout/transfer-charges"
                  element={<PayoutSystem />}
                />
                <Route
                  path="admin/adminPayout/reports"
                  element={<PayoutSystem />}
                />
                <Route
                  path="admin/adminPayout/audit-logs"
                  element={<PayoutSystem />}
                />
                {/*payout seystem*/}
              </Route>
              <Route
                path="/*"
                element={
                  <RouteAuth availableRoles={[Roles.admin, Roles.partner]} />
                }
              >
                {/*  <Route path=":accountType/merchantList/:partnerId" element={<Merchant />} /> */}
                <Route
                  path=":accountType/accountsmanagement/:partnerId/:acountTypeReport"
                  element={<Accounts />}
                />
                <Route
                  path=":accountType/softpos/dashboard/:partnerId"
                  element={<AdminSoftposDashboard />}
                />
                <Route
                  path=":accountType/payment/dashboard/:partnerId"
                  element={<AdminPaymentDashboard />}
                />
                <Route
                  path=":accountType/userManagement/:partnerId"
                  element={<UserManagementIndex />}
                />
                <Route
                  path=":accountType/appManagement/:partnerId"
                  element={<AppMngmnet />}
                />
                <Route
                  path=":accountType/:projectType/allReports/:partnerId/:reportName"
                  element={<Reports />}
                />
                <Route
                  path=":accountType/:partnerId/profile"
                  element={<Profile />}
                />
                <Route
                  path=":accountType/:projectType/:confiurationType/:configurationName/:partnerId"
                  element={<Configuration />}
                />
                <Route
                  path=":accountType/onlineRegisteration/:partnerId"
                  element={<OnlineRegisteration />}
                />
              </Route>
              <Route
                path="/*"
                element={
                  <RouteAuth
                    availableRoles={[
                      Roles.admin,
                      Roles.partner,
                      Roles.merchant,
                      Roles.user,
                      Roles.supervisor,
                    ]}
                  />
                }
              >
                <Route path="otp" element={<OTPScreen />} />
                <Route
                  path="merchant/:id/softpos/dashboard"
                  element={<MercahntSoftposDashboard />}
                />
                <Route path="merchant2/:id" element={<MerchantItem />} />
                <Route path="branches" element={<BranchesScreen />} />
                <Route path="branches/:id" element={<OutletScreen />} />
                <Route path="merchant/:id/users" element={<UsersScreen />} />
                <Route
                  path="merchant/:id/productManagement"
                  element={<ProductMng />}
                />
                <Route
                  path="merchant/:id/userManagement"
                  element={<UserManagementIndex />}
                />
                <Route path="users/:id" element={<UserScreen />} />
                <Route path="terminals" element={<TerminalsScreen />} />
                <Route path="terminals/:id" element={<TerminalScreen />} />
                <Route path="merchant/:id/customers" element={<Customers />} />
                <Route
                  path="merchant/:id/allDashboard"
                  element={<MerchantAllDashboard />}
                />
                <Route
                  path="merchant/:id/viewnotifications"
                  element={<ViewNotification />}
                />
                <Route
                  path="transactions/transactionsHistory"
                  element={<TransactionsScreen />}
                />
                <Route
                  path="reconciliation/reconciliationHistory"
                  element={<TerminalsReconcilationScreen />}
                />
                <Route
                  path="resetPasswordScreen"
                  element={<PasswordResetScreen />}
                />
                {/*Payment Gateway paths */}
                <Route
                  path="merchant/:id/paymentGateway/Dashboard"
                  element={<PaymentGatewayDashboard />}
                />
                <Route
                  path="merchant/:id/paymentGateway/transactions"
                  element={<Transaction />}
                >
                  <Route path="CardApplepay" element={<CardApplepay />} />{" "}
                  <Route path="Applepay" element={<ApplePay />} />{" "}
                  <Route path="Tamara" element={<TamaraTransactions />} />{" "}
                  <Route path="Sadad" element={<SadadTransactions />} />{" "}
                  <Route path="Tabby" element={<TabbyTransactions />} />{" "}
                  <Route
                    path="ClicToPay"
                    element={<ClickToPayTransactions />}
                  />
                </Route>
                <Route
                  path="merchant/:id/paymentGateway/payoutTransactions"
                  element={<MerchantPayoutTransactions />}
                />

                {/*E-Invoice paths */}
                <Route
                  path="merchant/:id/Invoice/createInvoice"
                  element={<CreateInvoiceCopy />}
                />
                <Route
                  path="merchant/:id/Invoice/InvoiceList"
                  element={<InvoiceHistory />}
                />
                <Route
                  path="merchant/:id/Invoice/:id"
                  element={<InvoiceScreen />}
                />
                {/* <Route path="merchant/:id/profile" element={<UserManagementIndex />} /> */}
                {<Route path="merchant/:id/profile" element={<Profile />} />}
                <Route
                  path="merchant/:id/settings"
                  element={<SettingsScreen />}
                >
                  {" "}
                  <Route path="Payment" element={<PaymentSettings />} />{" "}
                  <Route path="other" element={<OtherSettings />} />
                </Route>
              </Route>
            </Routes>
          </Suspense>
          <Toaster />
        </ThemeContext.Provider>
      </div>
    )
  );
};

export default App;
